import { useState } from "react";
import { Play } from "lucide-react";

function toEmbed(type, url) {
  if (type === "youtube" || /youtu/.test(url)) {
    const m = url.match(/(?:v=|youtu\.be\/|embed\/|shorts\/)([\w-]{6,})/);
    return `https://www.youtube-nocookie.com/embed/${m ? m[1] : url}`;
  }
  if (type === "soundcloud") {
    return `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%237a0000&show_comments=false`;
  }
  if (type === "spotify") {
    return url.replace("open.spotify.com/", "open.spotify.com/embed/");
  }
  return url;
}

function providerName(type, url) {
  if (type === "youtube" || /youtu/.test(url)) return "YouTube";
  if (type === "soundcloud" || /soundcloud/.test(url)) return "SoundCloud";
  if (type === "spotify") return "Spotify";
  return "the provider";
}

export default function EmbedConsent({
  type = "custom",
  url,
  title,
  thumbnail,
  className = "",
  aspect = "aspect-video",
  label,
  testId,
}) {
  const [ok, setOk] = useState(false);
  if (!url) return null;
  const provider = providerName(type, url);

  if (!ok) {
    return (
      <div
        data-testid="embed-consent"
        className={`relative ${aspect} w-full overflow-hidden border border-line bg-panel ${className}`}
      >
        {thumbnail && (
          <img
            src={thumbnail}
            alt={title || "Embedded media"}
            className="absolute inset-0 h-full w-full object-cover opacity-40"
            loading="lazy"
          />
        )}
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-5 p-6 text-center">
          <button
            data-testid="embed-load-button"
            onClick={() => setOk(true)}
            className="btn-ghost btn-small"
          >
            <Play className="h-4 w-4" /> {label || "LOAD PLAYER"}
          </button>
          <p className="text-[10px] tracking-[0.2em] text-white/40 max-w-xs">
            CONTENT FROM {provider.toUpperCase()} — LOADED ONLY AFTER YOUR CLICK
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`${aspect} w-full ${className}`} data-testid="embed-active">
      <iframe
        src={toEmbed(type, url)}
        title={title || `${provider} player`}
        data-testid={testId}
        className="h-full w-full"
        frameBorder="0"
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
        loading="lazy"
      />
    </div>
  );
}
